import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';

export function getIndustryCenterArticleContentPath({ articleCategory, articleId }) {
  return `/industry-center/${articleCategory}/${articleId}`;
}

export function getIndustryCenterArticleBreadcrumbs({ articleCategory, articleId, title }) {
  return [
    getHomeBreadcrumb(),
    getBaseBreadcrumb('Industry', `/industry/`),
    getBaseBreadcrumb('Industry Insights', `/industry/insights/`),
    getBaseBreadcrumb(title, `/industry-center/${articleCategory}/${articleId}.html`),
  ];
}
